var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-page"},[_c('div',{staticClass:"game-title"}),_c('div',{staticClass:"game-section"},[_c('IndexGame')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }